/* eslint-disable indent */
import {
  Paper,
  Select as MUISelect,
  TextField,
  Button as MUIButton,
  Stack
} from '@mui/material';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const Title = styled.p`
  font-weight: bold;
`;

export const TextSameLine = styled.div`
  display: flex;
  color: #888888;
  justify-content: space-around;
  width: 100%;
  flex: 1;
  flex-direction: row;
  margin
`;

export const ColumnText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 5px;

  > span {
    margin: 15px 15px;
  }
`;

export const InputContainerForm = styled(Stack)`
  display: flex;
  flex-direction: row !important;
  width: 100%;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column !important;
  }

  .dateInputResponsive {
    width: 192px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .selectInputResponsive {
    width: 152px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .btnResponsive {
    width: 110px;
    height: 40px;

    @media (max-width: 768px) {
      width: 100% !important;
    }
  }

  .comboResponsive {
    width: 192px;

    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100% !important;
  flex: 1;

  .descritionText {
    width: 100%;
    margin: 20px 0;
  }

  .descritionText input {
    height: 200px;
    width: 100%;
  }

  // .textArea {
  //   width: 100%;
  //   padding: 20px;
  //   height: auto;
  //   overflow: auto !important;
  //   padding-bottom: 20px !important;
  //   font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  //   font-weight: 400;
  //   line-height: 1.4375em;
  //   letter-spacing: 0.00938em;
  //   font-size: 16px;
  //   color: rgba(0, 0, 0, 0.4);
  //   margin-top: 5px;
  //   margin-bottom: 10px;
  //   border-radius: 4px;
  //   border: 1px solid #bbb;
  //   resize: none;
  // }

  span {
    margin-right: 20px;
    .bold {
      font-weight: 500;
    }

  .buttons {
    align-items: right;
  }
`;

export const InputDocumentContainer = styled(Stack)`
  display: flex;
  width: 100%;
  flex-direction: column !important;

  .searchStyle {
    cursor: initial;

    svg {
      color: #777;

      &:hover {
        color: #555;
      }

      &:onclick {
        font-size: 36px;
      }
    }

    svg:onclick {
      font-size: 36px;
      color: #f00;
    }
  }

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const Section = styled(Paper)`
  padding: 20px;
  width: 100%;
  margin-bottom: 10px;

  .textAreaContainer {
    position: relative;
    overflow: hidden;
  }

  hr {
    opacity: 0.5;
    margin: 20px 0;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
`;

export const ExpandBtn = styled.button`
  border: none;
  background-color: transparent;
`;

export const ExpandBtnNf = styled.button`
  border: none;
`;

export const ContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  gap: 10px;
`;

export const TextAreaTitle = styled.p`
  color: rgba(0, 0, 0, 0.4);
  background-color: #fff;
  padding: 0 5px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  display: block;
  transform-origin: top left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(133% - 24 px);
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1;
  pointer-events: none;
`;

export const FormButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
